import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  border: {
    property: 'border'
  },
  borderWidth: {
    property: 'borderWidth'
  },
  borderStyle: {
    property: 'borderStyle'
  },
  borderColor: {
    property: 'borderColor'
  },
  borderRadius: {
    property: 'borderRadius'
  },
  borderTop: {
    property: 'borderTop'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius'
  },
  borderRight: {
    property: 'borderRight'
  },
  borderBottom: {
    property: 'borderBottom'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius'
  },
  borderLeft: {
    property: 'borderLeft'
  },
  borderTopWidth: {
    property: 'borderTopWidth'
  },
  borderTopColor: {
    property: 'borderTopColor'
  },
  borderTopStyle: {
    property: 'borderTopStyle'
  },
  borderBottomWidth: {
    property: 'borderBottomWidth'
  },
  borderBottomColor: {
    property: 'borderBottomColor'
  },
  borderBottomStyle: {
    property: 'borderBottomStyle'
  },
  borderLeftWidth: {
    property: 'borderLeftWidth'
  },
  borderLeftColor: {
    property: 'borderLeftColor'
  },
  borderLeftStyle: {
    property: 'borderLeftStyle'
  },
  borderRightWidth: {
    property: 'borderRightWidth'
  },
  borderRightColor: {
    property: 'borderRightColor'
  },
  borderRightStyle: {
    property: 'borderRightStyle'
  }
};
const border = system(config);

export { border };
